import { ReservationAggregationService } from "../../../services/aggregation/reservationAggregation.service";
export var PROFILE_VISITS_PAGE_SIZE = 100;
var FRESH_MS = 30000;
export var profilePastVisitsQuery = function (profileId, limit) { return ({
    queryKey: ['profilePreview', 'pastVisits', profileId, limit],
    queryFn: function () { return ReservationAggregationService.listReservations({
        profileIds: [profileId],
        limit: { offset: 0, limit: limit, sort: [{ field: 'expectedEndDate', direction: 'DESC' }] }
    }); },
    staleTime: FRESH_MS,
    keepPreviousData: true
}); };
export var prefetchProfilePastVisits = function (queryClient, profileId) {
    queryClient.prefetchQuery(profilePastVisitsQuery(profileId, PROFILE_VISITS_PAGE_SIZE));
};
